import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SspContext from '../../../../contexts/SspContext'
import {
	ICreditBalance,
	INewCard,
	IUpdateCard,
	StatusCardActivation,
	StatusIssuer,
	StatusUser,
} from '../../../../interfaces/i-api-creaditCard'
import orderNewCardService from '../../../../services/CreditCardServices/orderNewCardService'
import updateCardStatusService from '../../../../services/CreditCardServices/updateCardStatusService'
import {
	checkIsMobile,
	getErrorWithFullMessage,
	getLanguageLocale,
} from 'shared'

const ActivateLockCard = () => {
	const { t } = useTranslation()
	const isMobile = checkIsMobile()
	const { overviewData, customerData } = useContext(SspContext)
	const [creditCardData] = useState(overviewData as ICreditBalance)
	const [loading, setLoading] = useState(false)
	const [success, setSuccess] = useState(false)
	const [error, setError] = useState<Error>()
	const [newStatus, setNewStatus] = useState<string>('')
	const [newDataSet, setNewDataSet] = useState<{
		type: string
		status: StatusIssuer
		statusDisplayed: string
		value: (IUpdateCard | INewCard)[]
		dropDown: string[]
	}>()
	const [currentStatus, setCurrentStatus] = useState<string>(
		newDataSet?.status!,
	)

	const note = 'user updated status via ssp'

	const updateCardStatus = async () => {
		setLoading(true)
		try {
			if (newStatus === StatusIssuer.OrderNewCard) {
				let newCard: INewCard
				newCard = {
					cardAgreementId: creditCardData.cardAgreementId,
					cardID: creditCardData.cardID,
				}
				await orderNewCardService(newCard, t).then(() => {
					setCurrentStatus(t('OrderNewCardStatus'))
					setNewDataSet({
						type: 'statusCardActivation',
						status: creditCardData.statusCardActivation
							.statusIssuer,
						statusDisplayed: t('OrderNewCardStatus'),
						value: [
							{
								id: '',
								cardAgreementId: creditCardData.cardAgreementId,
								cardId: creditCardData.cardID,
							},
						],
						dropDown: [''],
					})
					setSuccess(true)
					setLoading(false)
				})
			} else {
				await updateCardStatusService(
					newDataSet?.value.find(
						(x) => x.id === newStatus,
					) as IUpdateCard,
					t,
				).then((response) => {
					if (response.data.statusUser === 'Active') {
						setNewDataSet({
							type: 'statusCardActivation',
							status: creditCardData.statusCardActivation
								.statusIssuer,
							statusDisplayed: t('ActiveStatus'),
							value: [
								{
									id: 'Decline',
									statusUser: StatusUser.Decline,
									cardId: creditCardData.cardID,
									statusUserNote: note,
								},
								{
									id: 'PickUpGeneral',
									statusIssuer: StatusIssuer.PickUpGeneral,
									cardId: creditCardData.cardID,
									statusIssuerNote: note,
								},
								{
									id: 'OrderNewCard',
									cardAgreementId:
										creditCardData.cardAgreementId,
									cardId: creditCardData.cardID,
								},
							],
							dropDown: [
								'Decline',
								'PickUpGeneral',
								'OrderNewCard',
							],
						})
					} else if (response.data.statusUser === 'Decline') {
						setNewDataSet({
							type: 'statusUser',
							status: creditCardData.statusUser.statusIssuer,
							statusDisplayed: t('DeclineStatus'),
							value: [
								{
									id: 'Active',
									statusUser: StatusUser.Active,
									cardId: creditCardData.cardID,
									statusUserNote: note,
								},
								{
									id: 'PickUpGeneral',
									statusIssuer: StatusIssuer.PickUpGeneral,
									cardId: creditCardData.cardID,
									statusIssuerNote: note,
								},
								{
									id: 'OrderNewCard',
									cardAgreementId:
										creditCardData.cardAgreementId,
									cardID: creditCardData.cardID,
								},
							],
							dropDown: [
								'Active',
								'PickUpGeneral',
								'OrderNewCard',
							],
						})
					} else if (
						response.data.statusCardActivation === 'Inactive'
					) {
						setNewDataSet({
							type: 'statusCardActivation',
							status: creditCardData.statusCardActivation
								.statusIssuer,
							statusDisplayed: t('Inactive'),
							value: [
								{
									id: 'Active',
									statusCardActivation:
										StatusCardActivation.Active,
									cardId: creditCardData.cardID,
									statusCardActivationNote: note,
								},
							],
							dropDown: ['Active'],
						})
					} else if (response.data.statusIssuer === 'PickUpGeneral') {
						setNewDataSet({
							type: 'statusIssuer',
							status: creditCardData.statusIssuer.statusIssuer,
							statusDisplayed: t('PickUpGeneralStatus'),
							value: [
								{
									id: 'OrderNewCard',
									cardAgreementId:
										creditCardData.cardAgreementId,
									cardID: creditCardData.cardID,
								},
							],
							dropDown: ['OrderNewCard'],
						})
					}
					setCurrentStatus(newStatus!)
					setSuccess(true)
					setLoading(false)
				})
			}
		} catch (e: any) {
			setLoading(false)
			setError(getErrorWithFullMessage(e))
		}
	}
	const renderStatusData = () => {
		if (creditCardData.statusIssuer.statusIssuer === StatusIssuer.Active) {
			if (
				creditCardData.statusUser.statusIssuer === StatusIssuer.Active
			) {
				if (
					creditCardData.statusCardActivation.statusIssuer ===
					StatusIssuer.Active
				) {
					setNewDataSet({
						type: 'statusCardActivation',
						status: creditCardData.statusCardActivation
							.statusIssuer,
						statusDisplayed: t('ActiveStatus'),
						value: [
							{
								id: 'Decline',
								statusUser: StatusUser.Decline,
								cardId: creditCardData.cardID,
								statusUserNote: note,
							},
							{
								id: 'PickUpGeneral',
								statusIssuer: StatusIssuer.PickUpGeneral,
								cardId: creditCardData.cardID,
								statusIssuerNote: note,
							},
							{
								id: 'OrderNewCard',
								cardAgreementId: creditCardData.cardAgreementId,
								cardId: creditCardData.cardID,
							},
						],
						dropDown: ['Decline', 'PickUpGeneral', 'OrderNewCard'],
					})
				} else if (
					creditCardData.statusCardActivation.statusIssuer ===
					StatusIssuer.NotActive
				) {
					setNewDataSet({
						type: 'statusCardActivation',
						status: creditCardData.statusCardActivation
							.statusIssuer,
						statusDisplayed: t('Inactive'),
						value: [
							{
								id: 'Active',
								statusCardActivation:
									StatusCardActivation.Active,
								cardId: creditCardData.cardID,
								statusCardActivationNote: note,
							},
						],
						dropDown: ['Active'],
					})
				}
			} else if (
				creditCardData.statusUser.statusIssuer === StatusIssuer.Decline
			) {
				setNewDataSet({
					type: 'statusUser',
					status: creditCardData.statusUser.statusIssuer,
					statusDisplayed: t('DeclineStatus'),
					value: [
						{
							id: 'Active',
							statusUser: StatusUser.Active,
							cardId: creditCardData.cardID,
							statusUserNote: note,
						},
						{
							id: 'PickUpGeneral',
							statusIssuer: StatusIssuer.PickUpGeneral,
							cardId: creditCardData.cardID,
							statusIssuerNote: note,
						},
						{
							id: 'OrderNewCard',
							cardAgreementId: creditCardData.cardAgreementId,
							cardID: creditCardData.cardID,
						},
					],
					dropDown: ['Active', 'PickUpGeneral', 'OrderNewCard'],
				})
			}
		} else if (
			creditCardData.statusIssuer.statusIssuer ===
			StatusIssuer.PickUpGeneral
		) {
			setNewDataSet({
				type: 'statusIssuer',
				status: creditCardData.statusIssuer.statusIssuer,
				statusDisplayed: t('PickUpGeneralStatus'),
				value: [
					{
						id: 'OrderNewCard',
						cardAgreementId: creditCardData.cardAgreementId,
						cardID: creditCardData.cardID,
					},
				],
				dropDown: ['OrderNewCard'],
			})
		}
	}
	const onChangeSelect = (e: any) => {
		setNewStatus(e.target.value)
	}

	useEffect(() => {
		renderStatusData()
		// eslint-disable-next-line
	}, [creditCardData])

	useEffect(() => {
		setNewStatus(newDataSet?.dropDown[0] as string)
		setCurrentStatus(newDataSet?.statusDisplayed!)
	}, [newDataSet])

	let cls = ['d-flex', 'justify-content-between', 'mt-3']
	if (isMobile) cls.push('flex-column')

	const Column = (props: any) => {
		return (
			<div className="d-flex flex-column mt-3">
				<div>
					<b>{t(props.title)}</b>
				</div>
				{props.item}
			</div>
		)
	}

	return (
		<div className="container">
			<div className="fade-in active-lock-card outer-container p-4 mt-4">
				<div className="d-flex justify-content-between">
					<h5>{t('ActivateLockCard')}</h5>
				</div>
				<div className="d-flex">
					<div>{t('ActivateLockCardText')}</div>
				</div>
				<div className={cls.join(' ')}>
					<Column
						title="NameOnCard"
						item={`${customerData?.firstName} ${customerData?.lastName}`}
					/>
					<Column
						title="ExpirationDate"
						item={new Date(
							creditCardData.cardExpirationDate,
						).toLocaleDateString(getLanguageLocale(), {
							year: 'numeric',
							month: '2-digit',
						})}
					/>
					<Column title="Status" item={currentStatus} />
					<Column
						title="NewStatus"
						item={
							<select
								className="form-select"
								aria-label="New status"
								onChange={(e) => onChangeSelect(e)}
								value={newStatus}>
								{newDataSet?.dropDown.map(
									(item: string, key: number) => {
										return (
											<option key={key} value={item}>
												{t(item)}
											</option>
										)
									},
								)}
							</select>
						}
					/>
					<Column
						item={
							<button
								className="btn btn-primary"
								onClick={() => {
									updateCardStatus()
								}}>
								{loading ? (
									<div id="circle-spinner"></div>
								) : (
									<>{t('Confirm')}</>
								)}
							</button>
						}
					/>
				</div>
				{success && (
					<div className="d-flex flex-row-reverse mt-3">
						{t('UpdateCardStatusSuccess')}
					</div>
				)}
				{error && !loading && !success && (
					<div className="d-flex flex-row-reverse error-msg mt-3">
						{error.message}
					</div>
				)}
			</div>
		</div>
	)
}
export default ActivateLockCard
